import { NgModule, ModuleWithProviders, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Draggable } from './directives/draggable.directive';
import { Droppable } from './directives/droppable.directive';
import { DragDropService } from './services/dragdrop.service';

/**
 * Standalone provider function for DragDrop functionality.
 * Use this in app.config.ts providers array.
 */
export function provideDragDrop(): EnvironmentProviders {
    return makeEnvironmentProviders([DragDropService]);
}

/**
 * @deprecated Use `provideDragDrop()` instead and import directives directly in components.
 */
@NgModule({
    imports: [Draggable, Droppable],
    exports: [Draggable, Droppable],
})
export class DragDropModule {
    static forRoot(): ModuleWithProviders<DragDropModule> {
        return {
            ngModule: DragDropModule,
            providers: [DragDropService],
        };
    }
}
